import * as palette from "@govlaunch/palette";
import Link, { LinkProps } from "next/link";
import React, { HTMLAttributes, ReactNode } from "react";
import mediaQueries from "~/components/mediaQueries";
import CountBadge from "~/components/profile/CountBadge";
import { Margin } from "~/components/spacings";

interface IVendorOwnerNavbarGroupProps {
  title: string;
  active?: boolean;
  count?: number | null;
  dataIntercomTarget?: string | null;
  disabled?: boolean;
  children: ReactNode;
  icon: any;
  circleProps?: HTMLAttributes<HTMLDivElement>;
}

export default function VendorOwnerNavbarGroup({
  href,
  as,
  title,
  icon: Icon,
  active,
  dataIntercomTarget,
  disabled,
  children,
  count,
  circleProps,
  ...props
}: IVendorOwnerNavbarGroupProps & LinkProps & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-intercom-target={dataIntercomTarget}
      css={{
        background: active ? palette.lightestBlue : "#fff",
      }}
      {...props}
    >
      <Link href={href} as={as} passHref={true} legacyBehavior={true}>
        <a
          css={mediaQueries({
            display: "flex",
            padding: "8px 0 8px 24px",
            alignItems: "center",
            opacity: disabled ? 0.5 : 1,
            color: active ? palette.innovatorBlue : "#5A6677",
            fontWeight: active ? 600 : "normal",
            fontSize: 16,
          })}
        >
          <Margin mr={16}>
            <Icon width={24} height={24} color={active ? palette.innovatorBlue : palette.darkGray} />
          </Margin>
          {title}{" "}
          {!!count && count > 0 && active && (
            <CountBadge
              css={{
                backgroundColor: "#5A6677",
                color: palette.white,
              }}
              {...circleProps}
            >
              {count > 99 ? "99+" : count}
            </CountBadge>
          )}
        </a>
      </Link>

      {active && (
        <div
          css={mediaQueries({
            marginLeft: 36,
            textAlign: "left",
            borderLeft: `solid 2px ${active ? palette.innovatorBlue : palette.lightestGray}`,
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
}
